import { createContext, useContext, useState, ReactNode } from 'react';

export type KotchTheme = 'elegant' | 'tavern';

interface KotchThemeContextType {
  theme: KotchTheme;
  setTheme: (theme: KotchTheme) => void;
  toggleTheme: () => void;
}

const KotchThemeContext = createContext<KotchThemeContextType | undefined>(undefined);

export function KotchThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<KotchTheme>(() => {
    // Load saved preference
    const saved = localStorage.getItem('kotch-theme');
    return (saved === 'tavern' ? 'tavern' : 'elegant') as KotchTheme;
  });

  const handleSetTheme = (newTheme: KotchTheme) => {
    setTheme(newTheme);
    localStorage.setItem('kotch-theme', newTheme);
  };

  const toggleTheme = () => {
    handleSetTheme(theme === 'elegant' ? 'tavern' : 'elegant');
  };

  return (
    <KotchThemeContext.Provider value={{ theme, setTheme: handleSetTheme, toggleTheme }}>
      {children}
    </KotchThemeContext.Provider>
  );
}

export function useKotchTheme() {
  const context = useContext(KotchThemeContext);
  if (!context) {
    throw new Error('useKotchTheme must be used within a KotchThemeProvider');
  }
  return context;
}
